import { render } from "./BadgesAdmin-View.vue?vue&type=template&id=4c41aaf4&scoped=true"
import script from "./BadgesAdmin-View.vue?vue&type=script&lang=js"
export * from "./BadgesAdmin-View.vue?vue&type=script&lang=js"

import "./BadgesAdmin-View.vue?vue&type=style&index=0&id=4c41aaf4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c41aaf4"]])

export default __exports__